import { gql } from '@apollo/client';

export default gql`
  mutation updatePurchaseOrder(
    $_id: String
    $branch: String
    $docNo: String
    $prefix: String
    $title: String
    $time: Date
    $desc: String
    $supplier: SupplierInput
    $department: DepartmentInput
    $employee: EmployeeInput
    $project: ProjectInput
    $resourse: ResourseInput
    $contract: ContractInput
    $accounts: [AccountInput]
    $items: String
    $costAmount: Float
    $total: Float
    $discount: Float
    $amount: Float
    $profit: Float
    $paymentType: String
    $inhand: Float
    $change: Float
    $amountPaid: Float
    $payAcc: Int
    $isPaid: Boolean
    $isCash: Boolean
    $opId: String
    $attachments: String
    $manualInvNo: String
    $manualRecNo: String
    $manualOrdNo: String
    $eventId: Int
    $userId: String
  ) {
    updatePurchaseOrder(
      _id: $_id
      branch: $branch
      docNo: $docNo
      prefix: $prefix
      title: $title
      time: $time
      desc: $desc
      supplier: $supplier
      department: $department
      employee: $employee
      project: $project
      resourse: $resourse
      contract: $contract
      accounts: $accounts
      items: $items
      costAmount: $costAmount
      total: $total
      discount: $discount
      amount: $amount
      profit: $profit
      paymentType: $paymentType
      inhand: $inhand
      change: $change
      amountPaid: $amountPaid
      payAcc: $payAcc
      isPaid: $isPaid
      isCash: $isCash
      opId: $opId
      attachments: $attachments
      manualInvNo: $manualInvNo
      manualRecNo: $manualRecNo
      manualOrdNo: $manualOrdNo
      eventId: $eventId
      userId: $userId
    ) {
      ok
      message
      data
      error
    }
  }
`;
